import Api from "./baseApi";

export default {
  getCarousels: (isActive) => {
    let url = "/api/carousels";
    if (isActive !== undefined && isActive !== null) {
      url += `?isActive=${isActive}`;
    }
    return Api.get(url);
  },
  getCarousel: (id) => Api.get(`/api/carousels/${id}`),
  postCarousel: (carousel) => Api.post("/api/carousels", carousel),
  putCarousel: (id, carousel) => Api.put(`/api/carousels/${id}`, carousel),
  deleteCarousel: (id) => Api.delete(`/api/carousels/${id}`),
  updateCarouselOrder: (orderData) => Api.put("/api/carousels/update-order", orderData)
};

